export const GET_INDUSTRY_FULL_TREE_WATCHER = 'GET_INDUSTRY_FULL_TREE_WATCHER';
export const GET_INDUSTRY_FULL_TREE_SUCCESS = 'GET_INDUSTRY_FULL_TREE_SUCCESS';
export const GET_INDUSTRY_FULL_TREE_FAILED = 'GET_INDUSTRY_FULL_TREE_FAILED';
